<div class="listview container-fluid">
  <base-customer-external-employees-filters
    [branches]="branches"
    [qualifications]="mainQualifications"
    [departments]="departments"
    [filterValues]="filters"
    [filtersForm]="filtersForm"
    [isWorkCouncil]="isWorkCouncil"
  ></base-customer-external-employees-filters>

  <base-customer-external-employees-search-export
    (exportContracts)="exportContracts()"
    (exportAssignmentInfo)="exportAssignmentInfo()"
    [filtersForm]="filtersForm"
    [isWorkCouncil]="isWorkCouncil"
  ></base-customer-external-employees-search-export>

  <base-customer-external-employees-list-headline
    [allSelected]="allAssignmentsSelected"
    [isListEmpty]="!customerAssignments.length"
    [orderKey]="listOrderKey"
    [orderDirection]="listOrderDirection"
    [isWorkCouncil]="isWorkCouncil"
    (changeOrder)="sortAssignments($event)"
    (selectAll)="selectAll($event)"
  ></base-customer-external-employees-list-headline>

  <div
    class="listview-item"
    [ngClass]="{ 'no-pointer': isWorkCouncil }"
    *ngFor="let item of customerAssignments"
  >
    <base-customer-external-employees-list-item
      [assignmentListItem]="item"
      [listOrderKey]="listOrderKey"
      [listOrderDirection]="listOrderDirection"
      [filters]="filters"
      [page]="page"
      [pageSize]="size"
      [isWorkCouncil]="isWorkCouncil"
      (selectItem)="selectAssignment($event)"
    ></base-customer-external-employees-list-item>
  </div>

  <base-empty-list-row
    *ngIf="customerAssignmentsLoaded && !customerAssignments?.length"
    message="externalEmployees.emptyList"
  ></base-empty-list-row>
</div>

<div class="pagination">
  <base-pagination
    [page]="page"
    [size]="size"
    [itemsCount]="itemsCount"
  ></base-pagination>
</div>
